import * as React from "react";

const CompareActive: React.FC = () => {
    return (
<svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Icons/CompareActive</title>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icons/CompareActive">
            <rect id="Rectangle" stroke="#CCCCCC" fill="#FFFFFF" x="0.5" y="0.5" width="18" height="18" rx="2"></rect>
            <rect id="Rectangle" fill="#006BC0" x="3" y="3" width="13" height="13" rx="1"></rect>
        </g>
    </g>
</svg>

    );
};

export default React.memo(CompareActive);